import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Provider manually request invoice to be created
 */
export default async function createInvoice(
  appointmentId: string | number,
  onBehalfOf?: string,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/invoicing/manual_invoice_request/${appointmentId}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `create invoice failed: ${getErrorDetail(await res.text())}`,
    );
  }
  return;
}
